import "./SimulationStockChartComponent.scss";
import {IComponentOptions, IOnChanges, IOnDestroy} from "angular";
import {ChartApi} from "../../../../components/chartiq/components/chart/ChartApi";
import {Subject} from "rxjs/Subject";
import {LocalStorageService} from "../../../../types/NgStorage";
import {SimulationChartData} from "../model/SimulationChartData";
import {StockChartService} from "../service/StockChartService";
import {Scheduler} from "rxjs";

export const SimulationStockChart = "tfSimulationStockChart";

export function simulationStockChart(): IComponentOptions {
    return {
        templateUrl: "app/trade-simulator/components/stock-chart/chart/SimulationStockChartComponent.html",
        bindings: {
            chartData: "<"
        },
        controllerAs: "ctrl",
        controller: SimulationStockChartController
    };
}

export class SimulationStockChartController implements IOnDestroy, IOnChanges {

    public chartData: SimulationChartData | null;

    public chartApi: ChartApi;
    private destroy$ = new Subject<void>();

    /** @ngInject */
    public constructor(private $localStorage: LocalStorageService,
                       private stockChartService: StockChartService) {
    }

    public $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["chartData"] != null) {
            this.destroy$.next();

        }
    }

    public chartInitialized(api: ChartApi): void {
        this.destroy$.next();

        this.chartApi = api;

        this.restoreDrawings();
        this.restoreLayout();

        this.chartApi
            .layoutChanges
            .takeUntil(this.destroy$)
            .subscribeOn(Scheduler.async)
            .subscribe(this.saveLayout.bind(this));

        this.chartApi
            .drawingChanges
            .takeUntil(this.destroy$)
            .subscribeOn(Scheduler.async)
            .subscribe(this.saveDrawings.bind(this));
    }

    private saveLayout(): void {
        if (this.chartData != null && this.chartApi) {
            const data = this.chartApi.exportLayout(false);
            this.stockChartService.setLayoutFor(this.chartData.code, data);
        }
    }

    private restoreLayout(): void {
        if (this.chartData != null && this.chartApi != null) {
            const data = this.stockChartService.getLayoutFor(this.chartData.code);

            if (data != null) {
                delete data["symbols"];
                this.chartApi.importLayout(data);
                // For some reason ChartIQ doesn't like loading studies onto static data,
                // so we refresh the studies after load to make them appear correctly
                this.chartApi
                    .layoutChanges
                    .take(1)
                    .subscribe(() => this.chartApi.refreshAllStudies());
            } else {
                this.chartApi.removeAllStudies();
            }
        }
    }

    private saveDrawings() {
        if (this.chartData != null && this.chartApi != null) {
            const data = this.chartApi.exportDrawings();

            this.stockChartService.setDrawingsFor(this.chartData.simulationId, data);
        }
    }

    private restoreDrawings() {
        if (this.chartData != null && this.chartApi != null) {

            const data = this.stockChartService.getDrawingsFor(this.chartData.simulationId);

            if (data != null) {
                this.chartApi.importDrawings(data);
            }

        }
    }

    public $onDestroy(): void {
        this.destroy$.next();
    }
}
